export default __webpack_public_path__ + "static/media/high-risk-gauge-image.338eb053.png";